import { TableCell } from '@mui/material';
import classNames from 'classnames';
import * as React from 'react';
import shortid from 'shortid';

import { htmlSanitizer } from 'utils';

import { TASKS_COLUMNS } from '../../../constants';

import { CopyRacersTable as Model } from '../../../models';

import { RowType } from '../';
import { CopyRacersContext } from '../../../context';
import { FIELD_SHOW } from './show';

const { MAIN_COLUMNS } = TASKS_COLUMNS;

function TasksCellsComponent({ value }: RowType) {
  return (
    <CopyRacersContext.Consumer>
      {() => {
        return MAIN_COLUMNS.map((column) => {
          const generateShowFun = FIELD_SHOW[column as string];

          const show = generateShowFun && generateShowFun(new Model(value));
          const renderedValue = show();

          const rowData = () => {
            return { __html: htmlSanitizer(renderedValue) || '' };
          };

          return (
            <TableCell key={shortid()} className={classNames('editable-cell cell')}>
              <div dangerouslySetInnerHTML={rowData()} />
            </TableCell>
          );
        });
      }}
    </CopyRacersContext.Consumer>
  );
}

const CopyRacersTasksCells = React.memo<RowType>(TasksCellsComponent);

// @ts-ignore
export { CopyRacersTasksCells };
